import router from './routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/css/style.css'; 
import './assets/css/style-preset.css'; 
import './assets/css/style-correct.css'; 
import './assets/css/App.css';
import './assets/css/global.css';
import { RouterProvider } from 'react-router-dom';
import { ToastProvider } from './context/ToastContext';
import { AuthProvider } from './context/AuthContext';
import './i18n';
import { ThemeProvider } from './context/ThemeContext';
import { FileNavigatorProvider } from './context/FileNavigator';
import { ModalProvider } from './context/ModalContext';
import GlobalProvider from './context/GlobalContext';
import { SettingsContextProvider } from './context/SettingsContext';
   
const App = () => { 
    return (
        <>  
        <GlobalProvider>
            <ModalProvider> 
                <ThemeProvider>
                    <ToastProvider> 
                        <AuthProvider>  
                            
                                    <RouterProvider router={router}/>
                                  
                        </AuthProvider>
                    </ToastProvider>
                </ThemeProvider>
            </ModalProvider>
        </GlobalProvider> 
        </>
    );
}

export default App;
 